<template>
  <HgButton
    :class="$style.goBack"
    theme="ghost"
    iconPosition="left"
    icon="ArrowLeft"
    @click="handleClick()"
  >
    <span :class="$style.btnTxt">{{ buttonText }}</span>
  </HgButton>
</template>
<script lang="ts" setup>
import { HgButton } from '@smg-real-estate/domus';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

export interface Props {
  text?: string;
}

const { t } = useI18n();
const props = withDefaults(defineProps<Props>(), {
  text: '',
});
const emit = defineEmits(['onBack']);
const buttonText = computed(() => props.text || t('button.back'));

const handleClick = () => {
  emit('onBack');
};
</script>
<style lang="scss" module>
@use '@/assets/variables' as *;

.goBack {
  position: static;
  margin-left: calc($space-50 * -1);
  padding: calc($space-25 + 1px) $space-75 calc($space-25 + 1px) $space-50 !important;
  min-width: unset !important;
  font-weight: 400 !important;
  @include body-2;

  @include grid-media-query(sm) {
    margin-left: 0;
  }

  &:hover {
    color: $color-grey-90 !important;
  }

  [class*='HgIcon_icon'] {
    padding-left: 0;
    padding-right: $space-25;

    @include grid-media-query(sm) {
      [class*='HgIcon_icon'] {
        padding-left: calc($space-25 / 2);
      }
    }
  }

  [class*='HgIcon_iconDefault'] {
    height: $space-100;
    width: $space-100;
  }
}
.btnTxt {
  display: none;
  @include grid-media-query(sm) {
    display: block;
  }
}
</style>
